import { render, staticRenderFns } from "./coachLeaderManage.vue?vue&type=template&id=f6f4b000&scoped=true"
import script from "./coachLeaderManage.vue?vue&type=script&lang=ts"
export * from "./coachLeaderManage.vue?vue&type=script&lang=ts"
import style0 from "./coachLeaderManage.vue?vue&type=style&index=0&id=f6f4b000&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6f4b000",
  null
  
)

export default component.exports